import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import SignInIcon from "@mui/icons-material/Input";
import TextField from "@mui/material/TextField";

import FormAlert from "../../../components/Form/Field/FormAlert";
import classes from "../../../pages/Login/Login.module.css";
import LocalLoader from "../../../components/Loaders/Local";
import { redirectToSSO } from "../../../utils/helpers";

function SSOLogin({ message }) {
  const [loginError, setLoginError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: "onBlur",
  });

  const doLogin = async (data) => {
    setIsLoading(true);
    setLoginError(null);
    redirectToSSO("login", data);
  };

  const onError = (error) => {
    setLoginError({ type: "error", msg: error });
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (message && message.msg) setLoginError(message);
  }, [message]);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        className={classes.loginGrid}
      >
        <Grid
          item
          xs={12}
          sm={8}
          className={`${classes.flexCenter} ${classes.loginForm}`}
        >
          <Card className={classes.card} raised>
            <form onSubmit={handleSubmit(doLogin, onError)} noValidate>
              <CardHeader title="Sign-in" className={classes.cardHeader}>
                Sign-in
              </CardHeader>
              <CardContent sx={{ pb: 0 }}>
                <TextField
                  label="Email"
                  error={errors.email !== undefined}
                  type="email"
                  required
                  margin="normal"
                  variant="outlined"
                  helperText={errors.email ? errors.email.message : ""}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...register("email", {
                    required: "Email is required",
                    maxLength: {
                      value: 50,
                      message: "Email must not exceed 50 characters",
                    },
                    pattern: {
                      value:
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "Invalid email address",
                    },
                  })}
                  fullWidth
                />
              </CardContent>
              <CardActions
                disableSpacing
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  mb: 1,
                }}
              >
                <Button
                  startIcon={<SignInIcon />}
                  variant="contained"
                  type="submit"
                  disabled={!isValid}
                >
                  SIGN IN
                </Button>
              </CardActions>
            </form>
            {loginError && (
              <Grid
                container
                justifyContent="center"
                className={classes.errorItem}
              >
                <Grid item xs={11}>
                  <FormAlert
                    severity={loginError.type || "error"}
                    message={<span>{loginError.msg}</span>}
                  />
                </Grid>
              </Grid>
            )}
          </Card>
        </Grid>
      </Grid>
      <LocalLoader progress={isLoading} />
    </>
  );
}

export default SSOLogin;
